import './_styles.scss';
import React from 'react';
import { Navigation, Footer } from 'components';

export default function index() {
  return (
    <section className='Section-404'>

      <Navigation expand/>

      <div className="Section-Wrapper">

        <div className="Title">
          Uh oh, Pardon us, we're having some trouble finding this page!
        </div>

        <div className="Content">

          <div className="Caption Large">
            It may be because:
          </div>

          <ul className='Body-Copy'>
            <li className='copy'>The web address is typed incorrectly</li>
            <li className='copy'>The page has moved to a different address</li>
            <li className='copy'>The link or bookmark that took you here is outdated</li>
          </ul>

          <div className="Caption">
            Try checking the URL, and if that looks okay then use the search bar or links at the top of the page to find what you're looking for.
          </div>

        </div>

      </div>

      <Footer/>

    </section>
  )
}
